var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.animation == 'slideup' ? 'slideup' : 'slide',"mode":"out-in"}},[(_vm.isOpen)?_c('div',{staticClass:"slide-over-wrapper h-screen fixed z-50 top-0 right-0 overflow-y-auto",class:{
      'w-full': _vm.width == 'full',
      'w-3/4': _vm.width == 'quarter-to',
      'w-1/2': _vm.width == 'half',
      'w-1/4': _vm.width == 'quarter',
      'w-auto': _vm.width == 'auto',
      'bg-white': _vm.bgColor == 'white',
      'bg-secondary-darker text-secondary-invert': _vm.bgColor == 'dark',
      'bg-grey': _vm.bgColor == 'grey',
      'slide-sidebar': _vm.type == 'sidebar',
    }},[_c('span',{staticClass:"cursor-pointer absolute close-icon",on:{"click":function($event){return _vm.emitCollapse()}}},[_c('CloseIcon',{staticClass:"h-6 w-6"})],1),_c('div',{staticClass:"w-full h-full py-5 px-4"},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }